import Vue from 'vue'
import Router from 'vue-router'

import routing from '@/app/config/routing'
import authService from '@/users/services/auth-service'
import { Component } from 'vue-property-decorator'

Vue.use(Router)

const router = new Router({
  routes: routing.routes,
})

// Handles redirect if the page requires authentication.
router.beforeEach((to, from, next) => {
  const recordsWithRoles = to.matched.filter((record) => record.meta.roles)
  if (recordsWithRoles.length > 0) {
    const record = recordsWithRoles[0]
    if (authService.isInAnyRole(record.meta.roles)) {
      next()
    } else {
      // Store full path including params and query strings
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    }
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (authService.authenticated()) {
      next()
    } else {
      // Store full path including params and query strings
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    }
  } else {
    // Redirect authenticated users from home/login to inquiries-search
    if (
      (to.path === '/') &&
      authService.authenticated()
    ) {
      next('/inquiries-search')
    } else {
      next()
    }
  }
})

export default router
